<template>
  <div class="answer-container">
    <el-dialog
        :visible.sync="isShow"
        title="成绩详情"
        width="680px"
        :append-to-body="true"
        :close-on-click-modal="false"
        :show-close="true"
        @close="closeAnalysis"
        class="score-dialog"
    >
      <div class="header">
        <p>{{ scoreDetail.paperName }}</p>
      </div>

      <div class="total-score">
        <div class="score-value">
          <span>分数：</span>
          <span class="big-number"
                :class="{ 'score-red': scoreDetail.accuracy < 0.6 && scoreDetail.accuracy !== undefined }"
          >
            {{ scoreDetail.userScore || 0 }}
          </span>
          <span class="total">/{{ scoreDetail.paperScore }}</span>
        </div>
        <div class="stats">
          <div class="stat-item">班级排名<br><b>-/-</b></div>
          <div class="stat-item">准确率<br><b>{{ formatAccuracy(scoreDetail.accuracy) }} %</b></div>
          <div class="stat-item">用时<br><b>{{ scoreDetail.doTime }}分钟</b></div>
        </div>
      </div>

      <!-- 详细得分区域 -->
      <div class="detail-section">
        <h3>详细得分情况</h3>
        <div class="detail-content">
          <div class="question-types">
            <div><i class="el-icon-s-tools"></i> 题型得分</div>
            <div v-for="item in scoreData" class="type-item">
              <span class="detail-type">{{ item.key }}</span>
              <span class="score">{{ item.value }}</span>
            </div>
          </div>

          <div class="answer-status">
            <div><i class="el-icon-circle-check"></i> 答题情况</div>
            <div class="status-item">
              <span class="detail-type">答对题数</span>
              <span class="value green">{{ scoreDetail.questionCorrect || 0 }} 题</span>
            </div>
            <div class="status-item">
              <span class="detail-type">答错题数</span>
              <span class="value red">{{ scoreDetail.questionWrong  || 0}} 题</span>
            </div>
            <div class="status-item">
              <span class="detail-type">总分排名</span>
              <span class="value blue">↑</span>
            </div>
          </div>
        </div>
      </div>

      <template slot="footer">
        <div class="setting-container">
          <div class="setting-tips">
            <span>提示：编程题作为主观题暂未纳入自动评分统计，</span>
            <br>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;编程题按该题分数的 60% 核算。</span>
          </div>
          <!-- 子div2：按钮操作区域 -->
          <div class="setting-actions"> <!-- 修正类名拼写错误 -->
            <el-button @click="closeAnalysis()">关闭</el-button>
            <el-button type="success" @click="toExamRecord()">考试记录</el-button>
            <el-button type="primary" @click="viewAnalysis()">查看答题解析</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ScoreDetailDialog',
  props: {
    scoreDetail: {
      type: Object,
      default: () => ({})
    },
    isShow: {
      type: Boolean,
      default: false // 默认不显示
    }
  },
  data() {
    return {
      scoreData: {}
    }
  },
  // 监听 Prop 变化，执行“显示”逻辑
  watch: {
    isShow(newVal, oldVal) {
      if (newVal && !oldVal) {
      }
    }
  },
  methods: { // Vue2 方法定义在 methods 中
    viewAnalysis() {
      // 可补充查看解析的业务逻辑
      console.log('查看答题解析');

      let jumpRouter = this.$router.resolve({
        path: "/viewTestPaper?id=" + this.scoreDetail.id
      })
      window.open(jumpRouter.href, '_blank');
      window.close()
    },
    closeAnalysis() {
      this.$router.push({path: '/testPaperCenter'})
      window.scrollTo(0, 0)
    },
    toExamRecord() {
      this.$router.push({path: '/examinationRecord'})
      window.scrollTo(0, 0)
    },
    formatAccuracy(val) {
      const num = val * 100;
      return Number.isInteger(num) ? num : num.toFixed(2);
    },
    processedScoreData() {
      try {
        this.scoreData = JSON.parse(this.scoreDetail.questionTypeScore || '{}');
      } catch (e) {
        console.warn('解析 questionTypeScore 失败', e);
        scoreData = {};
      }

      let result = Object.entries(this.scoreData).map(([key, value]) => ({key, value}));

      // 3. 补充空白值，确保最少3个
      const minCount = 3;
      while (result.length < minCount) {
        result.push({key: '', value: ''}); // 空白项
      }
      this.scoreData = result;
      console.log('scoreData', scoreData)
    }
  },
  created() {
    this.processedScoreData()
  }
}
</script>

<style scoped>

.answer-container {
  width: 800px;
  z-index: 2000;
  overflow: hidden;
}

.score-dialog {
  --el-dialog-padding: 0;
}

.header {
  margin-top: -20px;
  padding: 0 14px 15px;
  margin-bottom: 4px
}

.header p {
  font-size: 16px;
  margin: 0;
}

.score-title {
  padding: 0 10px 5px;
  font-size: 12px;
}

.total-score {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 14px 20px;
}

.big-number {
  padding-left: 10px;
  margin-right: -10px;
  font-size: 48px;
  font-weight: bold;
  color: #409eff;
}

.total {
  font-size: 20px;
  color: #666;
  margin-left: 8px;
}

.stats {
  display: flex;
  gap: 20px;
}

.stat-item {
  text-align: center;
  background: #f5f7fa;
  padding: 10px 20px;
  border-radius: 8px;
  min-width: 80px;
}

.stat-item b {
  font-size: 18px;
  color: #333;
}

.detail-section {
  padding: 24px 14px 20px;
  margin-bottom: -24px;
}

.detail-section h3 {
  font-size: 18px;
  color: #333;
  margin: 0 0 15px;
  font-weight: 600;
}

/* 核心调整：新增flex容器控制左右分布 */
.detail-content {
  display: flex;
  justify-content: space-between; /* 左右两端对齐 */
  gap: 50px; /* 中间间距 */
}

/* 题型得分（居左） */
.question-types {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;

}

.detail-type {
  color: #222;
}

/* 答题情况（改为左对齐） */
.answer-status {
  flex: 1; /* 占比1份 */
  display: grid;
  grid-template-columns: 1fr;
  gap: 15px;
  justify-items: start; /* 关键修改：改为左对齐 */
}


.type-item, .status-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 8px;
  background: #f5f7fa;
  border-radius: 8px;
  font-size: 14px;
  width: 100%;
  max-width: 260px;
  height: 20px;
}

.score {
  color: #3B82F6;
  font-weight: 500;
}

.green {
  color: #67c23a;
  font-weight: 500;
}

.red {
  color: #f56c6c;
  font-weight: 500;
}

.blue {
  color: #409eff;
  font-weight: 500;
}

/* 关键修改1：Footer区域flex布局，实现文本和按钮同一直线 */
::v-deep .el-dialog__footer { /* Vue2 深度选择器用 ::v-deep 替代 :deep() */
  display: flex;
  justify-content: space-between; /* 文本左，按钮右 */
  align-items: center; /* 垂直居中 */
  padding: 16px 24px;
  border-top: 1px solid #eee; /* 可选：增加边框更美观 */
  margin: 0; /* 清除默认margin */
}

.setting-actions { /* 修正类名拼写错误 */
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

/* 父容器：Flex 布局核心样式 */
.setting-container {
  width: 98%;
  display: flex;
  align-items: center; /* 子元素垂直居中对齐 */
  justify-content: space-between; /* 两端对齐，提示文本靠左，按钮靠右 */
  gap: 4px; /* 两个子div之间的间距（避免挤压） */
}

.setting-tips {
  flex: 1; /* 自动拉伸，占据父容器剩余宽度 */
  color: #666;
  line-height: 1.5;
  font-size: 12px;
  text-align: left;
}

.setting-actions {
  display: flex;
  gap: 2px;
  white-space: nowrap; /* 防止按钮换行 */
}

/* 响应式适配：小屏幕下恢复垂直布局 */
@media (max-width: 768px) {
  .detail-content {
    flex-direction: column; /* 垂直排列 */
  }

  .answer-status {
    justify-items: start; /* 保持左对齐 */
  }

  .type-item, .status-item {
    max-width: 100%; /* 小屏幕下占满宽度 */
  }

  /* 小屏幕下footer改为垂直布局 */
  ::v-deep .el-dialog__footer {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .setting-actions {
    width: 100%;
    justify-content: flex-end;
  }
}

.big-number.score-red {
  color: #f56c6c; /* 红色，与答错题数视觉统一 */
}
</style>
